import { EPostbackCurrency } from '../../../types'
import { IPostbackCurrencyLang } from '../../../types/lang'

export const postbackCurrencyLang: IPostbackCurrencyLang = {
	postback_currency: {
		[EPostbackCurrency.Dollar]: 'Доллар, $',
		[EPostbackCurrency.Euro]: 'Евро, €',
	}
}